import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MessDetailsRoutingModule } from './mess-details-routing.module';
import { MessLinkComponent } from './mess-link/mess-link.component';
import { MessListComponent } from './mess-list/mess-list.component';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MessdetailsTableComponent } from './messdetails-table/messdetails-table.component';
import { ModuleRegistry } from "ag-grid-community";
import { AllEnterpriseModule, LicenseManager } from "ag-grid-enterprise";
import { environment } from 'src/environments/environment';
import { AgGridAngular, AgGridModule } from 'ag-grid-angular';
import { MessInventoryComponent } from './mess-inventory/mess-inventory.component';
import { AddItemDialogComponent } from './add-item-dialog/add-item-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { SupplyBuildingDialogComponent } from './supply-building-dialog/supply-building-dialog.component';
import { MessDoDetailsComponent } from './mess-do-details/mess-do-details.component';
import { MessDoDetailViewComponent } from './mess-do-detail-view/mess-do-detail-view.component';
import { MessClosedDetailsComponent } from './mess-closed-details/mess-closed-details.component';
import { MessExcelComponent } from './mess-excel/mess-excel.component';
import { MealRequestComponent } from './meal-request/meal-request.component';
import { AddMealRequestComponent } from './add-meal-request/add-meal-request.component';
import { MealOrderSummaryComponent } from './meal-order-summary/meal-order-summary.component';
import { MealOrderDialogComponent } from './meal-order-dialog/meal-order-dialog.component';
import { HolidayReasonViewDialogComponent } from './holiday-reason-view-dialog/holiday-reason-view-dialog.component';
import { NotSubmittedViewDialogComponent } from './not-submitted-view-dialog/not-submitted-view-dialog.component';
import { ApplyHolidayComponent } from './apply-holiday/apply-holiday.component';
import { HolidayCloseDialogComponent } from './holiday-close-dialog/holiday-close-dialog.component';
import { MenuDialogComponent } from './menu-dialog/menu-dialog.component';
import { MessSummaryDialogComponent } from './mess-summary-dialog/mess-summary-dialog.component';
import { DoMenuComponent } from './do-menu/do-menu.component';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
import { AddNewMenuItemComponent } from './add-new-menu-item/add-new-menu-item.component';
import { HttpClientModule } from '@angular/common/http';
import { AdminDivisionReportComponent } from './admin-division-report/admin-division-report.component';
import { ConfirmationMessageDialogComponent } from './confirmation-message-dialog/confirmation-message-dialog.component';
import { DaysheetcloseConfirmationMessageDialogComponent } from './daysheetclose-confirmation-message-dialog/daysheetclose-confirmation-message-dialog.component';
import { AdminMessInventoryComponent } from './admin-mess-inventory/admin-mess-inventory.component';
import { AdminMenuDialogComponent } from './admin-menu-dialog/admin-menu-dialog.component';
import { AdminSingleAdditemComponent } from './admin-single-additem/admin-single-additem.component';
import { MessHeaderComponent } from './mess-header/mess-header.component';
import { MessLandingPageComponent } from './mess-landing-page/mess-landing-page.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { MatTooltipModule } from '@angular/material/tooltip';


ModuleRegistry.registerModules([AllEnterpriseModule]);
LicenseManager.setLicenseKey(environment.ag_grid_key);

// Custom date format
// export const MY_DATE_FORMATS = {
//   parse: {
//     dateInput: 'DD MMM YYYY', // format you type in
//   },
//   display: {
//     dateInput: 'DD MMM YYYY', // format shown in input
//     monthYearLabel: 'MMM YYYY',
//     dateA11yLabel: 'LL',
//     monthYearA11yLabel: 'MMMM YYYY',
//   },
// };


export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD MMM YYYY',
  },
  display: {
    dateInput: 'DD MMM YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


@NgModule({
  declarations: [
    MessLinkComponent,
    MessListComponent,
    MessdetailsTableComponent,
    MessInventoryComponent,
    AddItemDialogComponent,
    SupplyBuildingDialogComponent,
    MessDoDetailsComponent,
    MessDoDetailViewComponent,
    MessClosedDetailsComponent,
    MessExcelComponent,
    MealRequestComponent,
    AddMealRequestComponent,
    MealOrderSummaryComponent,
    MealOrderDialogComponent,
    HolidayReasonViewDialogComponent,
    NotSubmittedViewDialogComponent,
    ApplyHolidayComponent,
    HolidayCloseDialogComponent,
    MenuDialogComponent,
    MessSummaryDialogComponent,
    DoMenuComponent,
    AdminDashboardComponent,
    AddNewMenuItemComponent,
    AdminDivisionReportComponent,
    ConfirmationMessageDialogComponent,
    DaysheetcloseConfirmationMessageDialogComponent,
    AdminMessInventoryComponent,
    AdminMenuDialogComponent,
    AdminSingleAdditemComponent,
    MessHeaderComponent,
    MessLandingPageComponent,
    SidebarComponent,
  ],
  imports: [
    CommonModule,
    MessDetailsRoutingModule,
    AcademicFormModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    FormsModule,
    NgxSpinnerModule,
    AgGridModule,
    AgGridAngular,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatTabsModule,
    HttpClientModule,
     MatTooltipModule
  ],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: MY_DATE_FORMATS
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'en-GB' // optional
    },
  ]

})
export class MessDetailsModule { }
